export const REQUEST_ERRORS_SCREENS = 'REQUEST_ERRORS_SCREENS'
export const REQUEST_ERRORS_FILES = 'REQUEST_ERRORS_FILES'
export const REQUEST_ERRORS_LISTS = 'REQUEST_ERRORS_LISTS'
export const REQUEST_ERRORS_SMS = 'REQUEST_ERRORS_SMS'
export const REQUEST_ERRORS_CARDS_DEBTS = 'REQUEST_ERRORS_CARDS_DEBTS'
